import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

import { PackingListEditComponent, PackingListListComponent, PackingListViewComponent } from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [PackingListEditComponent, PackingListListComponent, PackingListViewComponent],
  imports: [CommonModule, MutualModule, NgxPaginationModule, RouterModule, PipesSharedModule, FormWrapperModule],
  exports: [PackingListEditComponent, PackingListListComponent, PackingListViewComponent],
})
export class PackingListsModule {}
